import '../styles/alert.css';

export const TopBanner = () =>{
  return <div className='alert'>
    <p className='message'>LÍNEAS TELEFÓNICAS: <span className='number'>3526-3959 / 3532-6467</span></p>
  </div>
}